import { PreDiabetesScreen } from '@/components/PreDiabetesScreen';

export default function PreDiabetes() {
  return <PreDiabetesScreen />;
}
